export default {
    LoadFolders: {
        datapoint: {
            name: 'TnS_LoadFolders',
            customData: function (numInboxChildren) { return [numInboxChildren]; },
        },
    },
    ToggleFolderExpansion: {
        datapoint: {
            name: 'Triage_ToggleFolderExpansion',
            customData: function (folderDistinguishedIdName, expansionState) { return [
                folderDistinguishedIdName,
                expansionState,
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map